$(document).ready(function () {
    $(".add-to-cart").click(function () {


        $(this).addClass('btn-disabled');
        $(this).html("added");
        $('#viewcartid').show();
    });
});